import { render, staticRenderFns } from "./archive_design_button.vue?vue&type=template&id=8a7cbd50"
import script from "./archive_design_button.vue?vue&type=script&lang=js"
export * from "./archive_design_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports